import { useInstance } from 'intact-vue-next';
import dayjs from './dayjs';
import { isString } from 'intact-shared';
var FORMATS = {
  date: 'YYYY-MM-DD',
  datetime: 'YYYY-MM-DD HH:mm:ss',
  year: 'YYYY',
  month: 'YYYY-MM'
};
export function useFormats() {
  var instance = useInstance();
  function getValueFormat() {
    var _instance$get = instance.get(),
      format = _instance$get.format,
      valueFormat = _instance$get.valueFormat,
      type = _instance$get.type;
    return valueFormat || format || FORMATS[type];
  }
  function getShowFormat() {
    var _instance$get2 = instance.get(),
      format = _instance$get2.format,
      showFormat = _instance$get2.showFormat,
      type = _instance$get2.type;
    return showFormat || format || FORMATS[type];
  }
  function createDateByValueFormat(value) {
    return dayjs(value, isString(value) ? getValueFormat() : undefined);
  }
  function createDateByShowFormat(value) {
    return dayjs(value, getShowFormat(), true); // strict parsing 
  }
  function getShowString(value) {
    return value.format(getShowFormat());
  }
  function getValueString(value) {
    return value.format(getValueFormat());
  }
  return {
    getValueFormat: getValueFormat,
    getShowFormat: getShowFormat,
    createDateByValueFormat: createDateByValueFormat,
    createDateByShowFormat: createDateByShowFormat,
    getShowString: getShowString,
    getValueString: getValueString
  };
}